/**
 * motionTokens
 *
 * SHS Visual Experience System — Sprint 29.1A.
 *
 * The minimum set of motion tokens required to build the foundational
 * primitives (FadeIn, RiseIn, Reveal). Deliberately small.
 *
 * Later phases (29.2+) will extend this file with brand colors, cinematic
 * values, and physiology-signal parameters. Those additions require
 * separate written Founder authorization per the Strategic Constitution,
 * Article XI § 11.3.
 *
 * Do NOT import brand tokens here. This module is motion-only.
 */

// Durations expressed in milliseconds as numbers, and as CSS-consumable
// strings for direct interpolation into inline styles or CSS variables.
export const duration = Object.freeze({
  fast: 180,       // micro-interactions, small state changes
  standard: 320,   // section-level fades and rises
  slow: 560,       // larger reveals; used sparingly

  // CSS-ready variants (with unit).
  fastCss: '180ms',
  standardCss: '320ms',
  slowCss: '560ms',
});

// Standard easing curves. Named after intent, not shape, so callers can
// reason about them without remembering cubic-bezier values.
export const easing = Object.freeze({
  standard: 'cubic-bezier(0.4, 0, 0.2, 1)',   // general purpose
  enter: 'cubic-bezier(0, 0, 0.2, 1)',        // deceleration on entrance
  exit: 'cubic-bezier(0.4, 0, 1, 1)',         // acceleration on exit
});

// Distance tokens for translate-based entrances. Small integer pixel values,
// kept subtle to avoid layout-shift illusions on scroll-driven reveals.
export const distance = Object.freeze({
  subtle: 4,        // barely perceptible; suitable for dense UI
  standard: 8,      // default rise distance
});

const motionTokens = Object.freeze({ duration, easing, distance });

export default motionTokens;
